import { ChevronLeft, CloseSmall } from '@wix/wix-ui-icons-common/on-stage';
import React from 'react';
import { IconButton, Text } from '@wix/wix-ui-tpa/cssVars';
import { st, classes } from './HeaderWrapper.st.css';

const HeaderWrapper = ({ name, onClick, isMobile, onClose, disabled }: any) => {
  return (
    <div className={classes.headerWrapper}>
      <div className={classes.headerButton}>
        <IconButton
          className={classes.iconStyle}
          icon={disabled ? <ChevronLeft /> : <div />}
          onClick={onClick}
        />
        <Text className={st(classes.textStyle, { isMobile })}>{name}</Text>
      </div>
      {isMobile && (
        <div>
          <CloseSmall onClick={() => onClose && onClose()} />
        </div>
      )}
    </div>
  );
};

export default HeaderWrapper;
